import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../Actions/GlobalActions';
import CardBanque from './CardBanque';
import CardCopro from './CardCopro';
import CardNews from './CardNews';
import CardComptabilite from './CardComptabilite';

class MaCopro extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        if(this.props.Proprietaires == "EN_COURS_DE_CHARGEMENT") this.props.actions.chargeLsProprietaires()
        //recharge par défaut les dépenses de l'exercice en cours (si pas déjà chargé)
        if(this.props.Charges == "EN_COURS_DE_CHARGEMENT" || (this.props.NumExe !== 0 && this.props.NumExeCourant !== this.props.NumExe)) this.props.actions.obtenirChargesExeCourant()
    }

    render() {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-xl-4">
                        <CardCopro />
                        <CardBanque />
                    </div>
                    <div className="col-xl-4">
                        <CardNews />
                    </div>
                    <div className="col-xl-4">
                        <CardComptabilite />
                    </div>
                </div>
            </React.Fragment>
        )
    }
};

function mapStateToProps({
    CopStore : { Proprietaires, Charges, NumExe,
        Cop : { NumExeCourant }
    }
}) {
    return { Proprietaires, Charges, NumExe, NumExeCourant };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(Actions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(MaCopro);



// WEBPACK FOOTER //
// ./src/components/MaCopro/index.js